// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__QcSYF","formItem":"styles_formItem__krOJP","formFull":"styles_formFull__l5RE+","InputNumber":"styles_InputNumber__1DFGY"};